// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divContainerButtons{
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
  justify-content: flex-end;
}

.style {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
}

.css-iz5n0k-containerButtons { bottom: 0 !important; }

.divContainerButtons button {
  background-color: #3A56A1 !important;
  color: white !important;
  border: none !important;
  padding: 10px 20px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  margin-right: 10px !important;
  width: 100px !important;
}

.Emitida {
    width: 10px; /* Adjust width as needed */
    height: 10px; /* Adjust height as needed */
    background-color: #46c51a;
    border-radius: 50%; /* Creates a circle */
    display: inline-block; /* Ensures the element acts like text inline */
    margin-top: 6px;
  }

  .Cotizada{
    width: 10px; /* Adjust width as needed */
    height: 10px; /* Adjust height as needed */
    background-color: #4dc5f0;
    border-radius: 50%; /* Creates a circle */
    display: inline-block; /* Ensures the element acts like text inline */
    margin-top: 6px;
  }
  .Cancelada{
    width: 10px; /* Adjust width as needed */
    height: 10px; /* Adjust height as needed */
    background-color: #ef2f24;
    border-radius: 50%; /* Creates a circle */
    display: inline-block; /* Ensures the element acts like text inline */
    margin-top: 6px;
  }
  .Pendiente{
    width: 10px; /* Adjust width as needed */
    height: 10px; /* Adjust height as needed */
    background-color: #efd718;
    border-radius: 50%; /* Creates a circle */
    display: inline-block; /* Ensures the element acts like text inline */
    margin-top: 6px;
  }
  .Expirada{
    width: 10px; /* Adjust width as needed */
    height: 10px; /* Adjust height as needed */
    background-color: #f0972b;
    border-radius: 50%; /* Creates a circle */
    display: inline-block; /* Ensures the element acts like text inline */
    margin-top: 6px;
  }
  .centerTitle{
    color: #3A56A1;
    /* Heading/H4/Medium */
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 16px;
  }
  .box{
    border-radius: 8px;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
    padding: 20px;
    background-color: #fff;
  }`, "",{"version":3,"sources":["webpack://./src/salesCore/clientRecord/assets/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,+BAA+B,oBAAoB,EAAE;;AAErD;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;IACI,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB;IACzB,kBAAkB,EAAE,qBAAqB;IACzC,qBAAqB,EAAE,8CAA8C;IACrE,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB;IACzB,kBAAkB,EAAE,qBAAqB;IACzC,qBAAqB,EAAE,8CAA8C;IACrE,eAAe;EACjB;EACA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB;IACzB,kBAAkB,EAAE,qBAAqB;IACzC,qBAAqB,EAAE,8CAA8C;IACrE,eAAe;EACjB;EACA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB;IACzB,kBAAkB,EAAE,qBAAqB;IACzC,qBAAqB,EAAE,8CAA8C;IACrE,eAAe;EACjB;EACA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;IAC1C,yBAAyB;IACzB,kBAAkB,EAAE,qBAAqB;IACzC,qBAAqB,EAAE,8CAA8C;IACrE,eAAe;EACjB;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,sDAAsD;IACtD,aAAa;IACb,sBAAsB;EACxB","sourcesContent":[".divContainerButtons{\r\n  width: 100%;\r\n  display: flex;\r\n  text-align: right;\r\n  margin-bottom: 20px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.style {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  border-radius: 5px;\r\n  transform: translate(-50%, -50%);\r\n  box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;\r\n}\r\n\r\n.css-iz5n0k-containerButtons { bottom: 0 !important; }\r\n\r\n.divContainerButtons button {\r\n  background-color: #3A56A1 !important;\r\n  color: white !important;\r\n  border: none !important;\r\n  padding: 10px 20px !important;\r\n  border-radius: 5px !important;\r\n  cursor: pointer !important;\r\n  margin-right: 10px !important;\r\n  width: 100px !important;\r\n}\r\n\r\n.Emitida {\r\n    width: 10px; /* Adjust width as needed */\r\n    height: 10px; /* Adjust height as needed */\r\n    background-color: #46c51a;\r\n    border-radius: 50%; /* Creates a circle */\r\n    display: inline-block; /* Ensures the element acts like text inline */\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .Cotizada{\r\n    width: 10px; /* Adjust width as needed */\r\n    height: 10px; /* Adjust height as needed */\r\n    background-color: #4dc5f0;\r\n    border-radius: 50%; /* Creates a circle */\r\n    display: inline-block; /* Ensures the element acts like text inline */\r\n    margin-top: 6px;\r\n  }\r\n  .Cancelada{\r\n    width: 10px; /* Adjust width as needed */\r\n    height: 10px; /* Adjust height as needed */\r\n    background-color: #ef2f24;\r\n    border-radius: 50%; /* Creates a circle */\r\n    display: inline-block; /* Ensures the element acts like text inline */\r\n    margin-top: 6px;\r\n  }\r\n  .Pendiente{\r\n    width: 10px; /* Adjust width as needed */\r\n    height: 10px; /* Adjust height as needed */\r\n    background-color: #efd718;\r\n    border-radius: 50%; /* Creates a circle */\r\n    display: inline-block; /* Ensures the element acts like text inline */\r\n    margin-top: 6px;\r\n  }\r\n  .Expirada{\r\n    width: 10px; /* Adjust width as needed */\r\n    height: 10px; /* Adjust height as needed */\r\n    background-color: #f0972b;\r\n    border-radius: 50%; /* Creates a circle */\r\n    display: inline-block; /* Ensures the element acts like text inline */\r\n    margin-top: 6px;\r\n  }\r\n  .centerTitle{\r\n    color: #3A56A1;\r\n    /* Heading/H4/Medium */\r\n    margin: 0 auto;\r\n    text-align: center;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 32px;\r\n    margin-bottom: 16px;\r\n  }\r\n  .box{\r\n    border-radius: 8px;\r\n    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);\r\n    padding: 20px;\r\n    background-color: #fff;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
